import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken, type WithHydraPagination } from '~/api/utils'
import type { DocumentTemplateResponse, DocumentTemplateType } from '../types'

export const useDocumentTemplates = (
  type: DocumentTemplateType,
  agencyId?: number | null,
  options?: { enabled?: boolean }
) => {
  const agencyParam =
    agencyId != null
      ? `&agency=/v1/agencies/${agencyId}`
      : agencyId === null
        ? '&exists[agency]=false'
        : ''
  return useQuery<WithHydraPagination<DocumentTemplateResponse>>({
    queryKey: ['document-templates', type, agencyId ?? null],
    queryFn: ({ signal }) =>
      fetchApiWithToken<WithHydraPagination<DocumentTemplateResponse>>({
        url: `/v1/document_templates?type=${type}${agencyParam}`,
        useLDJson: true,
        signal
      }),
    enabled: options?.enabled ?? true,
    staleTime: 60_000
  })
}
